module.exports = __webpack_public_path__ + "img/svg/background-free-bet.9f1accf3c3b0f4f156d11a40cbf8a25d.svg";